import {
  USER_LOGIN,
  USER_LOGOUT,
  USER_FETCH_FAIL,
  USER_FETCH_START,
  USER_FETCH_SUCCESS,
  USER_IMPORT_JOB,
  USER_ATTRIBUTE,
} from "../actions/user";
import { UPDATE_ACCOUNT_SUCCESS, UPDATE_CURRENT_ROLE } from "../actions/account";
import { EMAIL_VERIFICATION_SUCCESS } from "../actions/email_verification";
import { httpReducer } from "../lib/create-action";
import adminLoginAs from "./admin_log_in_as";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import { reduceReducers } from "../lib/create-action";
import UserRoles from "../constants/roles";
import getDefaultRole from "../lib/user_roles";
import { userHasRole } from "../lib/user";
import UserStore from "../lib/user_store";
import { LOGIN_BY_ADVERTISER_CONTACT_TOKEN } from "../action_managers/forgot_password";

const initialState = {
  user: null,
  currentRole: UserRoles.Creator,
  isLoading: false,
};

function user(state = initialState, action) {
  switch (action.type) {
    case USER_FETCH_START:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case USER_FETCH_SUCCESS:
    case USER_LOGIN:
    case UPDATE_ACCOUNT_SUCCESS:
      return setCurrentUserOnState(state, action);
    case USER_FETCH_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
      });
    case EMAIL_VERIFICATION_SUCCESS:
      var newState = cloneDeep(state);
      set(newState, "user.hasVerifiedEmail", true);
      return newState;
    case USER_LOGOUT:
      return {
        isLoading: false,
        user: null,
      };
    default:
      return state;
  }
}

const loginWithAdvertiserContactToken = httpReducer(
  LOGIN_BY_ADVERTISER_CONTACT_TOKEN,
  initialState,
  {
    success: (state, action) => setCurrentUserOnState(state, { user: action.payload.resp }),
  }
);

function userRole(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CURRENT_ROLE:
      return { ...state, currentRole: action.role };
    default:
      return state;
  }
}

export function setCurrentUserOnState(state, action) {
  const currentRole = UserStore.getUserRole();
  let roleToSet;
  if (currentRole && userHasRole(action.user, currentRole)) {
    roleToSet = currentRole;
  } else if (action?.user?.role) {
    roleToSet = getDefaultRole(action.user);
  }
  return {
    ...state,
    isLoading: false,
    user: action.user,
    currentRole: roleToSet,
  };
}

const importJobReducer = httpReducer(USER_IMPORT_JOB, initialState, {
  success: (state, action) => ({ ...state, importJobs: action.payload.resp }),
  failure: (state, action) => ({ ...state, error: action.payload.error }),
});

const AttributeReducer = httpReducer(USER_ATTRIBUTE, initialState, {
  success: (state, action) => ({ ...state, user: action.payload.resp }),
});

export default reduceReducers(
  user,
  adminLoginAs,
  importJobReducer,
  AttributeReducer,
  userRole,
  loginWithAdvertiserContactToken
);
